export default __webpack_public_path__ + "static/media/kitchen3-before3-768w.a7cd473d.avif";